import { Box, CircularProgress } from '@mui/material';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { IFtseFx, useGetLatestFxDataLazyQuery } from '../../generated/graphql';
import { Colors } from '../../utils/theme';
import OverviewTable from '../Common/Tables/OverviewTable';
import { DATE_TIME_FORMATS } from '../../utils/constants';
import { LocalizationProvider } from '@mui/x-date-pickers';
import EpraDatePicker from '../Common/Fields/EpraDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const dateFormat = 'dd/MM/yyyy';

const FtseFxList: React.FunctionComponent = () => {
  const [date, setDate] = useState<Date | null>(null);
  const [getFtseFxData, { data, loading }] = useGetLatestFxDataLazyQuery({
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    getFtseFxData();
  }, []);

  useEffect(() => {
    if (date) {
      getFtseFxData({
        variables: {
          date: moment(date).format('YYYY-MM-DD')
        }
      });
    } else {
      getFtseFxData();
    }
  }, [date]);

  const renderDate = (rowData: IFtseFx, date: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return rowData[date]
      ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        moment(parseInt(rowData[date] as string)).format(DATE_TIME_FORMATS.DATE_AND_TIME_AM_PM)
      : '';
  };

  const columns = [
    {
      title: 'Date',
      field: 'date',
      sorting: false,
      render: (rowData: IFtseFx) => renderDate(rowData, 'date'),
      width: 430
    },
    {
      title: 'Currency Code',
      field: 'currency.code',
      width: 430
    },
    {
      title: 'Currency Id',
      field: 'currency.id',
      width: 430
    },
    {
      title: 'Rate Value',
      field: 'rate',
      width: 430,
      sorting: false
    }
  ];
  return (
    <Box>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: Colors.main,
            marginTop: '14%'
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box className="overviewPage">
          <Box className="print\:w-full">
            <OverviewTable
              columns={columns}
              data={data?.result || []}
              loading={loading}
              pageSize={15}
              additionalFilters={
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <EpraDatePicker
                    id="ftse-fx-date-picker"
                    label="Date"
                    value={date}
                    clearable={true}
                    onChange={(value) => setDate(value)}
                    format={dateFormat}
                  />
                </LocalizationProvider>
              }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FtseFxList;
